import { createContext, useContext } from 'react';

export type CommentsPermissions = {
    readonly canResolveThreads: boolean;
};

export const CommentsPermissionsContext = createContext<CommentsPermissions>({ canResolveThreads: false });

export const useCommentsPermissions = (): CommentsPermissions => useContext(CommentsPermissionsContext);
